import { AbstractControl, ValidatorFn } from "@angular/forms";
import { RegexList } from "constants/regex";

export function userNameValidator(): ValidatorFn {
    return (control: AbstractControl): Record<string, any> | null => {      
        const isEmail = RegexList.email.test(control.value);
        const isPhoneNumber = RegexList.phoneNumber.test(control.value);      
        return (isEmail || isPhoneNumber) ? null : {'error': 'not Valid'};
    }
}